import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {PraticaLight} from "../../../../../common/models/pratica/pratica-light";
import {CreazionePraticaStoreService} from "../../services/creazione-pratica-store.service";
import {TipoPratica} from "../../../../../common/models/tipologiche/tipo-pratica";
import {ElaborationDocumentFilterEntity} from "../../../../../document-management/models/elaboration-doc-filter";
import {Observable} from "rxjs";
import {PraticaPenale} from "../../../../../common/models/pratica/pratica-penale";
import { Classificazione } from "src/app/common/models/classificazione";


@Component({
  selector: 'app-step-dati-gen-pratica',
  templateUrl: './step-dati-gen-pratica.component.html',
  styleUrls: ['./step-dati-gen-pratica.component.css']
})
export class StepDatiGenPraticaComponent implements OnInit {

  @Input() entitiesMinerva: ElaborationDocumentFilterEntity;
  @Output() changeStep: EventEmitter<any> = new EventEmitter<any>();

  pratica: PraticaLight | PraticaPenale = null;
  tipoPratica: TipoPratica = null;
  classificazioni: Classificazione[] = null;
  entities: ElaborationDocumentFilterEntity[];
  validForm: boolean = true;
  resetForm: boolean = false;
  hasPrincipale: boolean = false;

  private datiGenerali: PraticaLight | PraticaPenale;

  constructor(
    private creazionePraticaStoreService: CreazionePraticaStoreService
  ) {
    this.creazionePraticaStoreService.pratica$.subscribe(response => this.pratica = response);
    this.creazionePraticaStoreService.tipoPratica$.subscribe(response => this.tipoPratica = response);
    this.creazionePraticaStoreService.classificazioni$.subscribe(response => {
        this.classificazioni = response;
        this.hasPrincipale = this.checkClassificazioni();
        this.updateValidityPratica();
      }
    );
    this.creazionePraticaStoreService.entities$.subscribe(entities => {
      this.entities = entities;
    });
  }

  ngOnInit() {
    /*this.creazionePraticaStoreService.checkClassificazioni().subscribe(res =>
      this.checkClassificazioni = res);*/
      //console.log("[PRATICA]",this.pratica);
      //console.log("[TIPO PRATICA]",this.tipoPratica);
      //console.log("[CLASSIFICAZIONI]",this.classificazioni);
  }

  updateDatiGenerali(pratica: PraticaLight) {
    this.datiGenerali = pratica;
    this.creazionePraticaStoreService.updatePratica(this.datiGenerali,this.tipoPratica,this.classificazioni);
  }

  reset() {
    this.resetForm = true;
    this.creazionePraticaStoreService.deleteAll(false);
    this.updateDatiGenerali(this.pratica);
  }

  setTipoPratica(tipoPratica: TipoPratica) {
    if(this.pratica == null){
      this.pratica = new PraticaLight();
    }
    this.tipoPratica = tipoPratica;
    this.pratica.tipoPratica = tipoPratica;
    this.creazionePraticaStoreService.updatePratica(this.datiGenerali, this.tipoPratica, this.classificazioni);
  }

  getMatter(): string {
    if (this.entities && this.entities.length > 0) {
      const matter = this.entities.find(el => el.tipoEntita.label_key.toLowerCase() === 'matter');
      return matter ? matter.valore : '';
    }
  }

  salva() {
    this.creazionePraticaStoreService.updatePratica(this.datiGenerali, this.tipoPratica, this.classificazioni);
    this.changeStep.emit();
  }

  changeValidity(isValid: boolean){
    // this.creazionePraticaStoreService.updateValidityPratica(isValid);
    this.validForm = isValid;
    this.updateValidityPratica();
  }

  checkDisabledBtn(): boolean {
    return !(this.validForm && this.checkClassificazioni());
  }

  addClassificazione(classificazione: Classificazione) {
    //console.log(classificazione);
    if(this.classificazioni == null){
      this.classificazioni = [];
    }
    if (this.classificazioni.length === 0) {
      classificazione.isPrincipale = true;
    }
    if (classificazione.isPrincipale) {
      this.classificazioni.forEach(item => item.isPrincipale = false)
    }
    this.classificazioni.push(classificazione);
    this.hasPrincipale = this.checkClassificazioni();
    this.updateValidityPratica();
  }

  removeClassificazione(classificazione: Classificazione) {
    //console.log(classificazione);
    let index = this.classificazioni.findIndex(el => el == classificazione);
    this.classificazioni.splice(index,1);
    this.hasPrincipale = this.checkClassificazioni();
    this.updateValidityPratica();
  }

  checkClassificazioni(): boolean{
    const isClassificazioniValid: boolean = this.classificazioni ? this.classificazioni.map(el => el.isPrincipale).includes(true) : false;
    return isClassificazioniValid;
  }

  updateValidityPratica(): void{
    this.creazionePraticaStoreService.updateValidityPratica(this.hasPrincipale && this.validForm);
  }

}
